import { React, useEffect } from "react";
import logoDeliceDeMaria from "../assets/images/delices-de-maria.png"
import logoItaloGourmet from "../assets/images/italogourmet.png"
import minLogo from "../assets/images/mini-logo.png"
import { connect } from "react-redux";
import Cart from "../componants/globals/CartResume";
import { IMAGE_URL } from "../config/BaseUrl";

const CartResume = ({ scaleWeight, shop }) => {

    return (
        <div className="h-[100vh] w-full flex flex-row justify-between">
            <div className="bg-white" style={{ backgroundColor: '#0F709E', display: 'flex', flexDirection: 'column', width: '40%', justifyContent: 'space-between' }}>
                <img className="h-[30%] w-[100%] mt-10" style={{ objectFit: 'contain' }} src={shop?.image ? (IMAGE_URL + shop?.image) : "https://admin.btip.be/static/media/logo-bg.5ba7da12.png"} alt="" />
                <div>
                    <p style={styles.weightUnit}>kg</p>
                    <p style={styles.weightValueLabel}>{scaleWeight}</p>
                </div>
                <div />
                <div className="flex items-center jusifty-center" style={{ alignSelf: 'center' }}>
                    <img className="h-[40px] w-[40px] mb-5 mr-2" style={{ objectFit: 'cover' }} src={minLogo} alt="" />
                    <p style={styles.powered}>Powerd by B-TIP</p>
                </div>
            </div>
            <div style={{ backgroundColor: 'red', display: 'flex', width: '60%' }}>
                <Cart />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        scaleWeight: state.global.scaleWeight,
        shop: state.auth.shops
    }
}

export default connect(mapStateToProps)(CartResume);

const styles = {

    weightValueLabel: {
        paddingLeft: 30,
        paddingRight: 30,
        color: 'white',
        fontWeight: 'bold',
        fontSize: 50,
        borderWidth: 3,
        borderRadius: 20,
        padding: 10,
        textAlign: 'right',
        marginLeft: 15,
        marginRight: 15,
        backgroundColor: '#2E9DD6'
    },
    weightUnit: {
        color: 'white',
        fontSize: 30,
        textAlign: 'right',
        marginLeft: 15,
        marginRight: 25
    },
    powered: {
        color: 'white',
        fontSize: 20,
        textAlign: 'center',
        marginBottom: 20
    }
}